<gstar-admin-prime-grid
  #grid
  [source]="source()"
  [headers]="headers"
  [showSearch]="false"
  [searchSetting]="searchSetting"
  [drawerSetting]="drawerSetting"
  [query]="queryWritable()"
  [normalActionMenu]="actionMenu"
  [actionMenuTitle]="actionMenuTitle"
  [gridSetting]="setting"
  [disableSelectAllModal]="true"
  (queryChange)="queryHandler($event)"
  (selectRows)="onItemsSelected($event)" />
